<template>
  <v-app v-if="$store.state.current.user.id">
        <v-navigation-drawer  v-model="drawer" mini-variant expand-on-hover app dark class="blue-grey darken-4"><Menu />
          <template v-slot:append>
            <v-list  color="red">
              <v-list-item class="px-2" link @click="logOut()">
                <v-list-item-avatar>
                  <v-icon>mdi-logout</v-icon>
                </v-list-item-avatar>
                <v-list-item-content>
                  <v-list-item-title>{{ $t('login.exit') }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </template>
        </v-navigation-drawer >
        <v-app-bar class="d-none d-print-block" dense>
          <v-toolbar-title>Adv-E</v-toolbar-title>
          <v-spacer></v-spacer>
          <div><span>{{$store.state.current.user.userName}}@{{$store.state.current.company.acronym}}</span> | <span>{{getCurrentDate()}}</span></div>
        </v-app-bar>
        <v-app-bar app dark class="blue darken-3 d-print-none" >
           <v-app-bar-nav-icon @click="drawer = !drawer"></v-app-bar-nav-icon>
           <v-toolbar-title style="cursor:pointer" @click="goInit">{{$store.state.current.company.acronym}} {{$store.state.current.stage.name}}</v-toolbar-title>
           <v-spacer></v-spacer>
          <role-select  v-if="$store.state.current.company" />
          <LocaleSelect mode="select" />
        </v-app-bar>
        <v-main app class="blue-grey lighten-5">
          <v-overlay :value="loadingData">
            <v-progress-circular
                indeterminate
                size="64"
              ></v-progress-circular>
            Preparando el sistema
          </v-overlay>
          <router-view class=""></router-view>
        </v-main>
  </v-app>
  <v-app v-else>
    <v-main>
      <v-container fill-height fluid  style="max-width:1200px">
        <v-row align="center" justify="center">
          <v-col>
            <div>
              <v-img src="@/assets/wait.svg" max-height="400" contain></v-img>
            </div>
            <div class="text-h5 text-center">
              <div>Configurando el sistema para ti</div>
              <div>
                <v-progress-circular indeterminate color="info"></v-progress-circular>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </v-main>
  </v-app>
</template>

<script>
import moment from 'moment'
import Menu from '../../components/app/Menu.vue'
import RoleSelect from '../../components/app/RoleSelect.vue'
import userService from '@/services/userServices'
import periodService from '@/services/periodServices'
import LocaleSelect from '../../components/app/util/LocaleSelect.vue'
export default {
    components:{Menu, RoleSelect, LocaleSelect},
    data: ()=>({
        drawer:null,
        loadingData: false
    }),
    beforeCreate(){
      if(localStorage.getItem("hope")){
        if(!this.$store.getters['current/isLogin']){
          this.loadingData = true;
          userService.getUserData().then(response=>{
            this.$store.commit('current/populateUser', response.data)

            /*periodService.getByStage(this.$store.state.current.stage.id).then(response=>{
              this.$store.commit('indicator/setPeriods', response.data)
            });
            */
            this.$store.commit('app/setSector', this.$store.state.current.sector);
            this.$store.commit('indicator/setPeriods', this.$store.state.periods);


            this.loadingData = false;
          })
          .catch( error => {
            console.error(error);
            this.$store.commit('current/logOut')
            this.$router.push("/login");
          })
        }else{
          this.$store.commit('current/logOut')
          this.$router.push("/login");
        }
      }else{
        this.$router.push("/login");
      }
    },
    methods:{
      logOut(){
        this.$store.commit('current/logOut')
        this.$router.push("/login");
      },
      goInit(){
        try{
          if(this.$route.path !== "/app"){
            this.$router.push("/app");
          }
          
        }catch{

        }
        
      },
      getCurrentDate(){
        return moment().format('DD/MM/yyyy HH:mm:ss')
      }
    },
    mounted(){

    }
}
</script>

<style>

</style>